import classNames from 'classnames';

export default {
  pnl: (value: number) =>
    classNames({
      'derivative-position-order-edit__price': true,
      'derivative-position-order-edit__price--up': value > 0,
      'derivative-position-order-edit__price--down': value < 0,
    }),
};
